<template>
  <div class="table-responsive" v-if="expanded">
    <input @change="performPictureUpload" id="fleDefaultPicUpload" type="file" style="display:none;" />
    
    <div class="card-body text-center" v-if="!hasPhoto">
      <div><img style="max-height: 64px;" src="../assets/nophoto.svg" /></div>
      
      <div style="padding-top: 15px;" v-if="canSave"><button class="btn btn-primary" @click="onPictureUpload">Upload Default Profile Picture</button></div>
    </div>
    
    <div class="card-body text-center" v-if="hasPhoto">
      <div>
        <img v-show="!objectURL" style="max-height: 200px;" src="../assets/ajax-loader.gif" />
        <img v-show="objectURL" style="max-height: 200px; border-radius: 24px; border: 1px solid #cccccc;" v-bind:src="objectURL" />
      </div>
      
      <div style="padding-top: 15px;" v-if="canSave"><button class="btn btn-primary" @click="onPictureUpload">Replace Default Profile Picture</button></div>
    </div>
  </div>
</template>

<script>
  import WebLLCRESTApi from "../api/api";
  
  export default {
    created() {
      this.api = new WebLLCRESTApi("Client-Images", this.$router);
      
      this.refreshImage();
    },
    
    props: {
      clientId: String,
      canSave: Boolean
    },
    
    data() {
      return {
        expanded: true,
        hasPhoto: false,
        objectURL: null
      };
    },
    
    destroy() {
      if(this.objectURL) {
        URL.revokeObjectURL(this.objectURL);
      }
    },
    
    methods: {
      expandPanel() {
        this.expanded = !this.expanded;
      },
      
      async refreshImage() {
        if(this.objectURL) {
          URL.revokeObjectURL(this.objectURL);
          this.objectURL = null;
        }
        
        const images = await this.api.getData(null, {
          where: {
            main: true,
            clientId: this.clientId
          }
        });
        
        if(images.length > 0) {
          this.hasPhoto = true;
          
          const res = await this.api.remoteMethod(images[0].id + "/image");
          const previewBlob = await res.blob();
          this.objectURL = URL.createObjectURL(previewBlob);
        }
        else {
          this.hasPhoto = false;
        }
      },
      
      async performPictureUpload(evt) {
        const files = evt.target.files;
        
        // remove any existing main/profile client images
        const existingImages = await this.api.getData(null, {
          where: {
            main: true,
            clientId: this.clientId
          }
        });
        
        for(var index=0; index<existingImages.length; index++) {
          await this.api.deleteData(existingImages[index].id);
        }
        
        // revoke the object url, so we see a loading bar during the upload process
        if(this.objectURL) {
          URL.revokeObjectURL(this.objectURL);
          this.objectURL = null;
        }
        
        this.hasPhoto = true;
        
        // upload all files
        for(var index=0; index<files.length; index++) {
          const file = files[index];
          
          const formData = new FormData();
          formData.append("description", "Profile Picture");
          formData.append("main", "true");
          formData.append("img", file);
          formData.append("clientId", this.clientId);
          
          const res = await this.api.addData(formData);
          const json = await res.json();
        }
        
        return this.refreshImage();
      },
      
      onPictureUpload() {
        document.getElementById("fleDefaultPicUpload").click();
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/DefaultPicUpload.vue